if (!customElements.get('mapl-mixed-offer')) {
  customElements.define('mapl-mixed-offer', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.form = this.querySelector('form');
      this.button = this.querySelector('.mapl-mixed-offer__add');
      this.label = this.button.querySelector('.mapl-button__label');
      this.originalLabel = this.label.textContent;
      this.status = this.querySelector('[role="status"]');
      this.error = this.querySelector('[role="alert"]');
      this.form.addEventListener('submit', (event) => this.add(event));
    }

    async add(event) {
      event.preventDefault();
      if (this.button.disabled) return;
      this.button.disabled = true;
      this.button.setAttribute('aria-busy', 'true');
      this.label.textContent = this.dataset.adding;
      this.error.hidden = true;
      this.status.textContent = '';
      const body = new FormData(this.form);
      body.delete('selling_plan');
      body.set('sections', 'cart-icon-bubble,cart-drawer');
      body.set('sections_url', window.location.pathname);
      const root = window.Shopify?.routes?.root || '/';
      const Events = window.StandardEvents;
      const deferred = Events?.CartLinesUpdateEvent?.createPromise();
      if (deferred) this.dispatchEvent(new Events.CartLinesUpdateEvent({
        action: 'add',
        context: 'product',
        lines: [{ merchandiseId: body.get('id'), quantity: 1 }],
        promise: deferred.promise
      }));
      if (typeof window.clarity === 'function') window.clarity('event', 'MaplMixedOfferAddToCartClicked');
      try {
        const response = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
          body
        });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || this.dataset.error);
        this.label.textContent = '✓ ' + this.dataset.added;
        this.button.classList.add('is-added');
        this.status.textContent = this.dataset.added;
        this.refreshSections(result.sections);
        if (typeof window.clarity === 'function') window.clarity('event', 'MaplMixedOfferAdded');
        const cartPromise = fetch(root + 'cart.js').then((res) => res.json()).then((cart) => {
          const bubble = document.getElementById('cart-icon-bubble');
          const label = bubble?.getAttribute('aria-label');
          if (label) bubble.setAttribute('aria-label', label.replace(/\(\d+/, '(' + cart.item_count));
          return cart;
        });
        if (deferred) cartPromise.then((cart) => deferred.resolve({
          cart: Events.CartLinesUpdateEvent.createCartFromAjaxResponse(cart)
        })).catch((error) => deferred.reject(error));
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          Promise.resolve(publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'mapl-mixed-offer',
            productVariantId: body.get('id'),
            cartData: result
          })).catch(() => {});
        }
        cartPromise.catch(() => {});
        this.resetTimer = window.setTimeout(() => {
          this.label.textContent = this.originalLabel;
          this.button.classList.remove('is-added');
          this.button.disabled = false;
        }, 5000);
      } catch (error) {
        deferred?.reject(error);
        this.error.textContent = error.message || this.dataset.error;
        this.error.hidden = false;
        this.label.textContent = this.originalLabel;
        this.button.disabled = false;
      } finally {
        this.button.removeAttribute('aria-busy');
      }
    }

    refreshSections(sections) {
      if (!sections) return;
      const parser = new DOMParser();
      const bubble = document.getElementById('cart-icon-bubble');
      const bubbleHTML = sections['cart-icon-bubble'];
      if (bubble && bubbleHTML) {
        const markup = parser.parseFromString(bubbleHTML, 'text/html').querySelector('.shopify-section');
        const count = markup?.querySelector('.cart-count-bubble');
        const currentCount = bubble.querySelector('.cart-count-bubble');
        if (count && currentCount) currentCount.replaceWith(count);
        else if (count) bubble.append(count);
        else currentCount?.remove();
      }
      const drawer = document.querySelector('cart-drawer');
      const drawerHTML = sections['cart-drawer'];
      if (drawer && drawerHTML) {
        const current = document.getElementById('CartDrawer');
        const markup = parser.parseFromString(drawerHTML, 'text/html').getElementById('CartDrawer');
        if (current && markup) {
          current.innerHTML = markup.innerHTML;
          drawer.classList.remove('is-empty');
          drawer.querySelector('#CartDrawer-Overlay')?.addEventListener('click', () => drawer.close());
        }
      }
    }

    disconnectedCallback() {
      if (this.resetTimer) window.clearTimeout(this.resetTimer);
    }
  });
}

